import styled from "styled-components";

const MainStyled = styled.div`
  width: 100%;
  margin: 31px auto 0px;
  font-family: Verdana, sans-serif;
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
  @media (max-width: 890px) {
    padding-top: 24px;
  }
  
`;

const WrapperStyled = styled.div`
  width: 100%;
  font-family: Verdana, sans-serif;
`;

export {
  MainStyled,
  WrapperStyled,
};
